export enum MiniGame {
  TheDeal1 = 1,
  TheDeal2 = 2,
  TheDeal3 = 3,
  CardMatch = 101,
  SuitRace = 102,
  SingleReel = 201,
  PickObject = 202,
  BonusWheel = 203,
  MatchDayMillions = 205
}
